import { useQuery } from "@tanstack/react-query";
import { cdFetch } from "../api";
import { queryKeys } from "../queryKeys";

const normalize = (input?: Array<string> | null) => {
  if (!Array.isArray(input) || input.length === 0) return null;
  return input.slice().sort();
};

export const useTMVsGrowthFilters = (filterEnable: boolean) => {
  const { data, isLoading }: any = useQuery({
    queryKey: [queryKeys.reportGrowthVsTm],
    queryFn: () => getGrowthVsTmFilter(),
    enabled: filterEnable,
    staleTime: 20000,
  });
  const GrowthVsTmFilterData = { ...data?.data?.data };
  return { GrowthVsTmFilterData, isLoading };
};

export function getGrowthVsTmFilter() {
  const res = cdFetch(`/getTMVsGrowthFilters`);
  return res;
}

export const useGrowthVsTmData = (
  commodity: string | string[],
  sales: string,
  time_period: string,
  drill: "Up" | "Down",
  district: string | string[],
  isJPExcluded: number = 1
) => {
  const { data, isLoading }: any = useQuery({
    queryKey: [
      queryKeys.reportGrowthVsTm,
      commodity,
      sales,
      time_period,
      drill,
      district,
      isJPExcluded,
    ],
    queryFn: () =>
      getReportGrowthVsTmData(commodity, sales, time_period, drill, district, isJPExcluded),
    enabled: !!(sales && time_period),
    staleTime: 20000,
  });
  const reportGrowthVsTmData = { ...data?.data?.data };
  return { reportGrowthVsTmData, isLoading };
};

export function getReportGrowthVsTmData(
  commodity: string | string[],
  sales: string,
  time_period: string,
  drill: "Up" | "Down",
  district: string | string[],
  isJPExcluded: number = 1
) {
  let qParams = "";

  if (commodity && commodity.length > 0 && commodity !== "All") {
    qParams += `commodity=${JSON.stringify(commodity)}&`;
  }
  if (sales && sales.length > 0) {
    qParams += `sales=${sales === "Pounds(lbs)" ? "LBS" : "DOLLAR"}&`;
  }

  if (time_period && time_period.length > 0) {
    qParams += `time_period=${JSON.stringify(time_period === "YTD" ? time_period : time_period.split("Trailing ")[1])}&`;
  }

  if (drill) {
    if (drill === "Down") {
      qParams += `level=Commodity&`;
    } else {
      qParams += "level=District&";
      if (district && district.length > 0) {
        qParams += `district=${JSON.stringify(district)}&`;
      }
    }
  }

  if (qParams.length > 0) {
    qParams = "?" + qParams.slice(0, -1);
  }
  const res = cdFetch(`/getTMVsSalesData${qParams}${qParams ? "&" : "?"}isJPExcluded=${isJPExcluded}`);
  return res;
}
